import { render, staticRenderFns } from "./scene17.vue?vue&type=template&id=6659a59e&scoped=true&"
import script from "./scene17.vue?vue&type=script&lang=ts&"
export * from "./scene17.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6659a59e",
  null
  
)

export default component.exports